import { apiClient } from './axiosInstance';

export const fetchPoliciesFilterList = async () => {
  return await apiClient.get(`/policies/base/policies`);
};
